import React from 'react';
import SmileyCertification from './SmileyCertification';
import PrivacyPolicy from './PrivacyPolicy';

export default function FooterCredit() {
  return (
    <div className="mt-8 pt-8 border-t border-red-700/30 space-y-4">
      <SmileyCertification />
      <div className="text-sm text-center space-y-2">
        <div>
          <PrivacyPolicy />
        </div>
        Designet af{' '}
        <a 
          href="https://www.pleatech.io" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hover:text-yellow-200 transition-colors"
        >
          Plea Tech
        </a>
      </div>
    </div>
  );
}